<template>
  <div class="text-center">
    <v-dialog
      v-model="showStakeholderFilesComponent"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline primary white--text"
          primary-title
        >
          {{ stakeholder.get_full_name }}'s Files:
          <v-spacer />
          <v-btn @click="toggleViewOfDropzone = !toggleViewOfDropzone">
            Add File
          </v-btn>
        </v-card-title>
        <v-card-text
          v-if="filterFiles.length !== 0"
          class="cardText"
        >
          <v-list
            two-line
            max-height="170"
            class="listContainer"
          >
            <v-list-item
              v-for="(item, index) in filterFiles"
              :key="index"
            >
              <v-list-item-avatar>
                <v-icon v-if="!!files[item.file.split('.').pop()]">
                  {{ files[item.file.split('.').pop()] }}
                </v-icon>
                <v-icon v-else>
                  {{ files.file }}
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                {{ item.file_name }}
              </v-list-item-content>
              <v-list-item-action>
                <v-menu
                  bottom
                  right
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="forceFileDownload(item.file, item.file_name)">
                      <v-list-item-title>
                        Download
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      :href="item.file"
                      target="_blank"
                    >
                      <v-list-item-title>Open In New Tab</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deleteStakeholderFile(item.pk)">
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-text
          v-else
          class="text-center"
        >
          This Person Has No Files To Display.
        </v-card-text>
        <v-card-text v-if="toggleViewOfDropzone">
          <StakeholderFileDropzone :stakeholder="stakeholder" />
        </v-card-text>
        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="$emit('show-stakeholder-files-component-action', false); toggleViewOfDropzone = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { mapActions } from 'vuex';
import StakeholderFileDropzone from './StakeholderFileDropzone'

export default {
  name: "StakeholderFiles",
  components: {
    StakeholderFileDropzone
  },
  props: { showStakeholderFilesComponent: { type: Boolean, default: () => false },
    stakeholderFiles: { type: Array, default: () => [] },
    stakeholder: { type: Object, default: () => {
      return {"pk": -1 }
    } }
  },
  data() {
    return {
      files: {
        html: 'mdi-language-html5',
        js: 'mdi-nodejs',
        json: 'mdi-json',
        md: 'mdi-markdown',
        pdf: 'mdi-file-pdf',
        png: 'mdi-file-image',
        jpeg: 'mdi-file-image',
        jpg: 'mdi-file-image',
        txt: 'mdi-file-document-outline',
        xls: 'mdi-file-excel',
        xlsx: 'mdi-file-excel',
        csv: 'mdi-file-delimited',
        doc: 'mdi-file-word',
        docx: 'mdi-file-word',
        file: 'mdi-file'
      },
      filteredFilesByStakeholder: [],
      toggleViewOfDropzone: false
    }
  },
  computed: {
    filterFiles () {
      return this.stakeholderFiles.filter(files => files.stakeholder === this.stakeholder.pk)
    }
  },
  methods: {
    ...mapActions({
      deleteStakeholderFile: "stakeholderFiles/deleteStakeholderFile"
    }),
    forceFileDownload(url, fileName) {
      axios({method: 'get', url: url, responseType: 'arraybuffer' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName +'.'+ response.config.url.split(".").pop())
          document.body.appendChild(link)
          link.click()
        })
    }
  }
}
</script>
<style scoped>
.listContainer {
  overflow-y: auto;
}
.cardText {
  padding: 2% !important;
}
</style>
